import { useEffect } from "react";

type UseRedirectOptions = {
  fallbackUrl?: string;
  enabled?: boolean;
};

export function useRedirect({ fallbackUrl = "/", enabled = true }: UseRedirectOptions = {}) {
  useEffect(() => {
    if (!enabled) return;

    const urlParams = new URLSearchParams(window.location.search);
    const redirectParam = urlParams.get("redirect");

    // Case 1: redirect query param
    if (redirectParam) {
      window.location.href = redirectParam;
      return;
    }

    // Case 2: same-origin referrer
    const referrer = document.referrer;
    const sameOrigin = referrer && new URL(referrer).origin === window.location.origin;

    if (sameOrigin &&  window.location.href !== referrer) {
      window.location.href = referrer;
      return;
    }

    // Case 3: fallback (root or provided fallback)
    window.location.href = fallbackUrl ? fallbackUrl : "/";
  }, [enabled, fallbackUrl]);
}



